// extracted by mini-css-extract-plugin
module.exports = {"inputMessageBlock":"InputMessage_inputMessageBlock__3FvcZ","inputMessage":"InputMessage_inputMessage__RMEKp","textArea":"InputMessage_textArea__kj3cQ"};